import React from "react";
import logo from "assets/img/logo-light.png";
import { FooterContainer, FooterMain, Logo, LinkList, Note } from "./style";
import getIcon from "util/getIcon";

export default function Footer() {
    return (
        <FooterMain>
            <FooterContainer>
                <Logo href="#">
                    <img src={logo} alt="Norberto Ignacio Logo" />
                </Logo>
                <Note>&copy; Norberto Ignacio Jr 2020</Note>
                <LinkList>
                    <li>
                        <a
                            href="https://twitter.com/theAspiringDev1"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <svg>
                                <use href={getIcon("twitter")} />
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://github.com/theAspiringDev1"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <svg>
                                <use href={getIcon("github1")} />
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=norbertoignaciojr@gmail.com&su=Let's talk!"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <svg>
                                <use href={getIcon("email")} />
                            </svg>
                        </a>
                    </li>
                </LinkList>
            </FooterContainer>
        </FooterMain>
    );
}
